"use client"

import { memo } from "react"

import PlayerMobil from "@/app/layouts/sidebarRight/PlayerMobil"

type Props = {
  variant?: "drawer" | "embedded"
  onClose?: () => void
}

function PlayerContent({
  variant = "drawer",
  onClose,
}: Props) {
  return (
    <div
      className="
        flex
        h-auto
        min-h-dvh
        w-full
        flex-col
        overflow-hidden
        overscroll-none
        text-white
      "
    >
      <div
        className="
          min-h-0
          flex-1
          w-full
          overflow-hidden
          overscroll-hidden
        "
      >
        <PlayerMobil
          variant={variant}
          onClose={onClose}
        />
      </div>
    </div>
  )
}

export default memo(PlayerContent)